import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '../../icon/icon';

import styles from './close_button.css';

const CloseButton = ({ stateProps: { eventHandler }, id }) => (
    <span className={styles.closeIcon}>
        <a
            tabIndex={0}
            role="button"
            aria-label="close call options"
            onClick={ () => eventHandler({ id })}>
            <Icon variant="ctm_cross" />
        </a>
    </span>
);

CloseButton.propTypes = {
    stateProps: PropTypes.object,
    id: PropTypes.string
};

export { CloseButton };
